module.exports = __webpack_public_path__ + "static/media/location.df9ba8e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/location.svg
// module id = 261
// module chunks = 1